export interface ActivityEnvironment {
  id: string;
  template_id: string;
  hostname: string | null;
  status: string;
  jobs: { action: string; status: string; error: string | null }[] | null;
}

export function activityEnvironmentReady(environment: ActivityEnvironment): boolean {
  return (
    environment.status === 'ready' &&
    !environment.jobs?.some((job) => job.status === 'queued' || job.status === 'running')
  );
}

/** Wait only for the selected personal environment, never a different site that became ready first. */
export async function waitForActivityEnvironment(options: {
  environmentId: string;
  read: () => Promise<ActivityEnvironment[]>;
  wait: () => Promise<void>;
  cancelled: () => boolean;
  attempts?: number;
}): Promise<ActivityEnvironment | null> {
  for (let attempt = 0; attempt < (options.attempts ?? 90); attempt++) {
    if (options.cancelled()) return null;
    const environment = (await options.read()).find((entry) => entry.id === options.environmentId);
    if (options.cancelled()) return null;
    if (!environment || environment.status === 'archived' || environment.status === 'failed')
      return null;
    if (activityEnvironmentReady(environment)) return environment;
    await options.wait();
  }
  return null;
}
